import store from '@/store'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import BleConnectionManager from '@/ble/connectionManager'
import { BleProviderEventTypes } from '@/ble/constants'
import {
  isEcgServiceWaveFormValues,
  isEcgServiceHeartRateValues
} from '@/types/utils'
import { WebSocketEcgMessageTypes } from '../receivers/ecg'
import dayjs from 'dayjs'

export const createECGConnection = () => {
  const ws = WebSocketProvider.createConnection()
  if (store.state.user.info.isPatient) {
    const ecgLongSave = store.getters['appSettings/systemConfig']('ecgLongSave')
    if (ecgLongSave === false) {
      store.commit('ecg/disableLargeData')
    }
    let prevSentTime = 0
    let measurementTime: string | null = null
    const buffer: number[] = []
    BleConnectionManager.provider.addListener(
      BleProviderEventTypes.RECEIVE_ECG_SERVICE,
      value => {
        if (isEcgServiceWaveFormValues(value)) {
          if (!measurementTime) {
            measurementTime = value.datetime
          }
          buffer.push(...value.ecg)
          const now = dayjs().valueOf()
          if (!prevSentTime || prevSentTime + 1000 < now) {
            ws.send(WebSocketMessageMode.ECG, {
              type: WebSocketEcgMessageTypes.ECG_SEND,
              ecg: buffer,
              measurementDate: measurementTime
            })
            store.commit('ecg/pushLoadData', {
              data: {
                ecg: buffer,
                measurementTime: new Date(measurementTime)
              }
            })
            buffer.length = 0
            prevSentTime = now
            measurementTime = null
          }
        }
        if (isEcgServiceHeartRateValues(value)) {
          ws.send(WebSocketMessageMode.ECG, {
            type: WebSocketEcgMessageTypes.PR_SEND,
            pr: value.heartRate,
            measurementDate: value.datetime
          })

          store.commit('ecg/setPr', value.heartRate)
        }
      }
    )
  }
}
